module.exports = __webpack_public_path__ + "media/images/accordion2-6ed10c484dabb8e516d03a8f2c202e4a.jpg";